import { useContext, useEffect } from "react";
import useAuth from "@hooks/useAuth";
import { NotificationsContext } from "@contexts/Notifications/context";

const SUMMARY_POLLING_INTERVAL_MS = 60_000;

export const useNotificationsBootstrap = () => {
  const isAuthenticated = Boolean(useAuth().user);
  const { refreshSummary } = useContext(NotificationsContext);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    let isUnmounted = false;
    let loading = false;

    const pollNotificationsSummary = async () => {
      if (loading || isUnmounted) {
        return;
      }

      loading = true;

      try {
        await refreshSummary();
      } catch (error) {
        console.error(
          "[Notifications] Erro ao carregar resumo de notificações",
          error,
        );
      } finally {
        loading = false;
      }
    };

    void pollNotificationsSummary();

    const interval = globalThis.setInterval(() => {
      void pollNotificationsSummary();
    }, SUMMARY_POLLING_INTERVAL_MS);

    return () => {
      isUnmounted = true;
      globalThis.clearInterval(interval);
    };
  }, [isAuthenticated, refreshSummary]);
};
